// // import React, { useState, useEffect, useRef } from "react";
// // import { Link ,useNavigate} from "react-router-dom";
// // import Slider from "react-slick";
// // import "slick-carousel/slick/slick.css";
// // import "slick-carousel/slick/slick-theme.css";
// // import httpClient from "../../utils/httpClients";

// // function Playlist() {
// //   const sliderRef = useRef(null);
// //   const sliderPlayRef = useRef(null);
// //   const navigate = useNavigate();

// //   const [playlists, setPlaylists] = useState([]);
// //   const [adminPlaylist, setAdminPlaylist] = useState([]); // Fixed: Added missing state
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);
// //   const [currentPage, setCurrentPage] = useState(1);
// //   const [totalPages, setTotalPages] = useState(1);
// //   const itemsPerPage = 12;
// //   const [genres, setGenres] = useState([]);
// //   const fetchTrendingSongs = async (page = 1) => {
// //     try {
// //       setLoading(true);
// //       setError(null);

// //       const res = await httpClient.get(
// //         `user/playlist/get-playlists?page=${page}&limit=${itemsPerPage}`
// //       );

// //       if (res.data && res.data.success) {
// //         const songsData = res.data.data?.playlist || [];
// //         setPlaylists(songsData);

// //         // Calculate total pages based on total count from API
// //         const totalCount = res.data.data?.totalCount || 0;
// //         setTotalPages(Math.ceil(totalCount / itemsPerPage));

// //         console.log("📊 Playlists loaded:", songsData.length);
// //       } else {
// //         setError("Failed to fetch playlists");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching playlists");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //    useEffect(() => {
// //     window.scrollTo(0, 0);
// //   }, []);

// //   const fetchGenresSongs = async () => {
// //     try {
// //       setError(null);
// //       const res = await httpClient.get(`/user/music/get-themes`);

// //       if (res.data?.success) {
// //         const data = res.data.data.getThemes || [];
// //         setGenres(data);
// //       } else {
// //         setError("Failed to fetch genre data");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching genre data");
// //     }
// //   };

// //   const fetchSongsPlaylist = async () => {
// //     try {
// //       setError(null);
// //       const res = await httpClient.get(`/user/music/get-admin-playlist`);

// //       if (res.data?.success) {
// //         const data = res.data.data.getPlaylists || []; // Fixed: assuming this returns an array
// //         setAdminPlaylist(data);
// //       } else {
// //         setError("Failed to fetch admin playlist data");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setError("Error fetching admin playlist data");
// //     }
// //   };

// //   useEffect(() => {
// //     fetchGenresSongs();
// //     fetchSongsPlaylist();
// //   }, []);

// //   useEffect(() => {
// //     fetchTrendingSongs(currentPage);
// //   }, [currentPage]);

// //   const handlePageChange = (page) => {
// //     setCurrentPage(page);
// //     window.scrollTo(0, 0);
// //   };

// //   // Fixed: Corrected variable name from sliderplaySettings to sliderPlaySettings
// //   const sliderPlaySettings = {
// //     dots: false,
// //     infinite: true,
// //     speed: 500,
// //     slidesToShow: 6,
// //     slidesToScroll: 3,
// //     arrows: false,
// //     responsive: [
// //       {
// //         breakpoint: 1024,
// //         settings: {
// //           slidesToShow: 4,
// //           slidesToScroll: 3,
// //         },
// //       },
// //       {
// //         breakpoint: 768,
// //         settings: {
// //           slidesToShow: 3,
// //           slidesToScroll: 2,
// //         },
// //       },
// //       {
// //         breakpoint: 480,
// //         settings: {
// //           slidesToShow: 2,
// //           slidesToScroll: 1,
// //         },
// //       },
// //     ],
// //   };

// //   const sliderSettings = {
// //     dots: false,
// //     infinite: true,
// //     speed: 500,
// //     slidesToShow: 6,
// //     slidesToScroll: 3,
// //     arrows: false,
// //     responsive: [
// //       {
// //         breakpoint: 1024,
// //         settings: {
// //           slidesToShow: 4,
// //           slidesToScroll: 3,
// //         },
// //       },
// //       {
// //         breakpoint: 768,
// //         settings: {
// //           slidesToShow: 3,
// //           slidesToScroll: 2,
// //         },
// //       },
// //       {
// //         breakpoint: 480,
// //         settings: {
// //           slidesToShow: 2,
// //           slidesToScroll: 1,
// //         },
// //       },
// //     ],
// //   };
// // const handleClick = () => {
// //     navigate('/list'); // or your wishlist route
// //   };
// //   const CustomNextArrow = () => (
// //     <div
// //       className="swiper-button-next"
// //       id="next1"
// //       tabIndex={0}
// //       role="button"
// //       aria-label="Next slide"
// //       onClick={() => sliderRef.current?.slickNext()}
// //       style={{ cursor: "pointer" }}
// //     >
// //       <svg
// //         xmlns="http://www.w3.org/2000/svg"
// //         width="18"
// //         height="19"
// //         viewBox="0 0 18 19"
// //         fill="none"
// //       >
// //         <path
// //           d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
// //           fill="currentColor"
// //         />
// //       </svg>
// //     </div>
// //   );

// //   const CustomPrevArrow = () => (
// //     <div
// //       className="swiper-button-prev"
// //       id="prev1"
// //       tabIndex={0}
// //       role="button"
// //       aria-label="Previous slide"
// //       onClick={() => sliderRef.current?.slickPrev()}
// //       style={{ cursor: "pointer" }}
// //     >
// //       <svg
// //         xmlns="http://www.w3.org/2000/svg"
// //         width="18"
// //         height="19"
// //         viewBox="0 0 18 19"
// //         fill="none"
// //       >
// //         <path
// //           d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
// //           fill="#4A525F"
// //         />
// //       </svg>
// //     </div>
// //   );

// //   const PlayNextArrow = () => (
// //     <div
// //       className="swiper-button-next"
// //       id="next1"
// //       tabIndex={0}
// //       role="button"
// //       aria-label="Next slide"
// //       onClick={() => sliderPlayRef.current?.slickNext()}
// //       style={{ cursor: "pointer" }}
// //     >
// //       <svg
// //         xmlns="http://www.w3.org/2000/svg"
// //         width="18"
// //         height="19"
// //         viewBox="0 0 18 19"
// //         fill="none"
// //       >
// //         <path
// //           d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
// //           fill="currentColor"
// //         />
// //       </svg>
// //     </div>
// //   );

// //   const PlayPrevArrow = () => (
// //     <div
// //       className="swiper-button-prev"
// //       id="prev1"
// //       tabIndex={0}
// //       role="button"
// //       aria-label="Previous slide"
// //       onClick={() => sliderPlayRef.current?.slickPrev()}
// //       style={{ cursor: "pointer" }}
// //     >
// //       <svg
// //         xmlns="http://www.w3.org/2000/svg"
// //         width="18"
// //         height="19"
// //         viewBox="0 0 18 19"
// //         fill="none"
// //       >
// //         <path
// //           d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
// //           fill="#4A525F"
// //         />
// //       </svg>
// //     </div>
// //   );

// //   // Render pagination component
// //   const renderPagination = () => {
// //     if (totalPages <= 1) return null;

// //     const pages = [];
// //     const maxVisiblePages = 5;
// //     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
// //     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

// //     if (endPage - startPage + 1 < maxVisiblePages) {
// //       startPage = Math.max(1, endPage - maxVisiblePages + 1);
// //     }

// //     // Previous button
// //     pages.push(
// //       <li
// //         key="prev"
// //         className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
// //       >
// //         <button
// //           className="page-link"
// //           onClick={() => handlePageChange(currentPage - 1)}
// //           disabled={currentPage === 1}
// //         >
// //           &laquo;
// //         </button>
// //       </li>
// //     );

// //     // Page numbers
// //     for (let i = startPage; i <= endPage; i++) {
// //       pages.push(
// //         <li
// //           key={i}
// //           className={`page-item ${currentPage === i ? "active" : ""}`}
// //         >
// //           <button className="page-link" onClick={() => handlePageChange(i)}>
// //             {i}
// //           </button>
// //         </li>
// //       );
// //     }

// //     // Next button
// //     pages.push(
// //       <li
// //         key="next"
// //         className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
// //       >
// //         <button
// //           className="page-link"
// //           onClick={() => handlePageChange(currentPage + 1)}
// //           disabled={currentPage === totalPages}
// //         >
// //           &raquo;
// //         </button>
// //       </li>
// //     );

// //     return (
// //       <nav aria-label="Playlist pagination">
// //         <ul className="pagination justify-content-center">{pages}</ul>
// //       </nav>
// //     );
// //   };

// //   return (
// //     <div className="content-inner pb-0 container-fluid" id="page_layout">
// //       {/* Breadcrumb and Title */}
// //       <div className="row row--grid">
// //         <div className="col-12">
// //           <ul className="breadcrumb">
// //             <li className="breadcrumb__item">
// //               <Link to="/">Home</Link>
// //             </li>
// //             <li className="breadcrumb__item breadcrumb__item--active">
// //               My Playlist
// //             </li>
// //           </ul>
// //         </div>
// //         <div className="col-12">
// //           <div className="main__title main__title--page">
// //             <h2 className="card-title text-capitalize mt-3">My PlayList</h2>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Loading State */}
// //       {loading && (
// //         <div className="row">
// //           <div className="col-12 text-center">
// //             <div className="spinner-border text-primary" role="status">
// //               <span className="visually-hidden">Loading...</span>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Error State */}
// //       {error && (
// //         <div className="row">
// //           <div className="col-12">
// //             <div className="alert alert-danger" role="alert">
// //               {error}
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* Playlists Grid */}
// //       <div className="row row--grid">
// //         <div className="col-12">
// //           <div className="row row--grid">
// //             {playlists.length > 0
// //               ? playlists.map((playlist) => (
// //                   <div
// //                     key={playlist._id} // Fixed: Changed from playlist.id to playlist._id
// //                     className="col-12 col-sm-4 col-lg-3 mb-4"
// //                   >
// //                     <div className="live">
// //                       <Link
// //                         to={`/playlists/${playlist._id}`} // Fixed: Using Link instead of anchor tag
// //                         className="live__cover open-video"
// //                       >
// //                         <img
// //                           src={playlist.playlistCoverUrl || "img/live/1.jpg"}
// //                           alt={playlist.name}
// //                           onError={(e) => {
// //                             e.target.src = "img/live/1.jpg";
// //                           }}
// //                         />
// //                         <svg
// //                           xmlns="http://www.w3.org/2000/svg"
// //                           viewBox="0 0 24 24"
// //                         >
// //                           <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
// //                         </svg>
// //                       </Link>
// //                       <h5 className="live__title">
// //                         <Link
// //                           to={`/playlists/${playlist._id}`}
// //                           className="open-video"
// //                         >
// //                           {playlist.description}
// //                         </Link>
// //                       </h5>
// //                       <h3 className="live__title">
// //                         <Link
// //                           to={`/playlists/${playlist._id}`}
// //                           className="open-video"
// //                         >
// //                           {playlist.name}
// //                         </Link>
// //                       </h3>
// //                     </div>
// //                   </div>
// //                 ))
// //               : !loading && (
// //                   <div className="col-12 text-center">
// //                     <p>No playlists found.</p>
// //                   </div>
// //                 )}
// //           </div>

// //           {/* Pagination */}
// //           {renderPagination()}
// //         </div>
// //       </div>

// // <div className="row">
// //   <div className="col-lg-12 mb-5">
// //     <div className="card-header mb-3">
// //       <div className="header-title">
// //         <h4 className="card-title text-capitalize">
// //           WishList <i className="fa fa-heart" aria-hidden="true"></i>
// //         </h4>
// //       </div>
// //     </div>

// //     <div className="row row--grid">
// //       <div className="col-12">
// //         <div className="row row--grid">
// //           <div className="col-12 col-sm-6 col-lg-4 mb-4">
// //             <div className="live" onClick={handleClick} style={{ cursor: 'pointer' }}>
// //               <div className="live__cover">
// //                 <img src={`${process.env.PUBLIC_URL}/img/covers/cover3.jpg`} alt="cover" />
// //                 <svg
// //                   xmlns="http://www.w3.org/2000/svg"
// //                   viewBox="0 0 24 24"
// //                 >
// //                   <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
// //                 </svg>
// //               </div>
// //               <h3 className="live__title">
// //                 My Favorite Songs
// //               </h3>
// //               <h5 className="live__description">
// //                 A collection of my all-time favorite tracks and melodies
// //               </h5>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   </div>
// // </div>
// //       {/* Admin Playlist Section */}
// //       <div className="row">
// //         <div className="col-lg-12 mb-5">
// //           <div className="card-header mb-3">
// //             <div className="header-title">
// //               <h4 className="card-title text-capitalize">
// //                 top song playlist for you
// //               </h4>
// //             </div>
// //             <div className="common-album position-relative d-lg-block d-none">
// //               <PlayPrevArrow />
// //               <PlayNextArrow />
// //             </div>
// //           </div>

// //           <div className="swiper overflow-hidden" data-swiper="geners-slider">
// //             <Slider ref={sliderPlayRef} {...sliderPlaySettings}> {/* Fixed: variable name */}
// //               {adminPlaylist.map((genre) => ( // Fixed: variable name
// //                 <div key={genre._id} className="swiper-slide mb-3">
// //                   <Link
// //                     to={`/admin-playlists/${genre._id}`}
// //                     className="text-capitalize line-count-1 h5 d-block"
// //                   >
// //                     <img
// //                       src={genre.coverImageUrl}
// //                       id={genre._id}
// //                       className="mb-3 img-fluid rounded-3"
// //                       alt="song-img"
// //                     />
// //                     {genre.name}
// //                   </Link>
// //                   <small className="fw-normal text-capitalize line-count-1">
// //                     {genre.description}
// //                   </small>
// //                 </div>
// //               ))}
// //             </Slider>
// //           </div>
// //         </div>
// //       </div>

// //       {/* Top Genres Section */}
// //       <div className="row">
// //         <div className="col-lg-12 mb-5">
// //           <div className="card-header mb-3">
// //             <div className="header-title">
// //               <h4 className="card-title text-capitalize">
// //                 top song genres for you
// //               </h4>
// //             </div>
// //             <div className="common-album position-relative d-lg-block d-none">
// //               <CustomPrevArrow />
// //               <CustomNextArrow />
// //             </div>
// //           </div>

// //           <div className="swiper overflow-hidden" data-swiper="geners-slider">
// //             <Slider ref={sliderRef} {...sliderSettings}>
// //               {genres.map((genre) => (
// //                 <div key={genre._id} className="swiper-slide mb-3">
// //                   <Link
// //                     to={`/party-music/${genre._id}`}
// //                     className="text-capitalize line-count-1 h5 d-block"
// //                   >
// //                     <img
// //                       src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
// //                       id={genre._id}
// //                       className="mb-3 img-fluid rounded-3"
// //                       alt="song-img"
// //                     />
// //                     {genre.name}
// //                   </Link>
// //                   <small className="fw-normal text-capitalize line-count-1">
// //                     {genre.description}
// //                   </small>
// //                 </div>
// //               ))}
// //             </Slider>
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // export default Playlist;

// import React, { useState, useEffect, useRef } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import httpClient from "../../utils/httpClients";
// import { usePlayer } from "../../../PlayerContext"; // ADD THIS

// function Playlist() {
//   const sliderRef = useRef(null);
//   const sliderPlayRef = useRef(null);
//   const navigate = useNavigate();

//   const [playlists, setPlaylists] = useState([]);
//   const [adminPlaylist, setAdminPlaylist] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const itemsPerPage = 12;
//   const [genres, setGenres] = useState([]);

//   const { triggerQueueUpdate, isPlaying, togglePlayPause } = usePlayer(); // ADD

//   // === ADD ALL TO QUEUE - SMART TYPE DETECTION ===
//   const addAllToQueue = async (playlistId, type) => {
//     try {
//       const res = await httpClient.post("user/queue/queue-controller", {
//         action: "addAllToQueue",
//         playlistId,
//         type, // "playlist" | "like" | "genresong"
//       });
//       if (res.data?.success) {
//         triggerQueueUpdate();
//         if (!isPlaying) togglePlayPause();
//         return true;
//       }
//     } catch (err) {
//       console.error("Add all to queue failed:", err);
//     }
//     return false;
//   };

//   // === HANDLE PLAY ALL FOR ANY TYPE ===
//   const handlePlayAll = async (id, type) => {
//     await addAllToQueue(id, type);
//   };
//   const handlelike = () => {
//         navigate('/like'); // or your wishlist route
//       };
//   const fetchTrendingSongs = async (page = 1) => {
//     try {
//       setLoading(true);
//       setError(null);
//       const res = await httpClient.get(
//         `user/playlist/get-playlists?page=${page}&limit=${itemsPerPage}`
//       );
//       if (res.data?.success) {
//         setPlaylists(res.data.data?.playlist || []);
//         const totalCount = res.data.data?.totalCount || 0;
//         setTotalPages(Math.ceil(totalCount / itemsPerPage));
//       } else {
//         setError("Failed to fetch playlists");
//       }
//     } catch (err) {
//       setError("Error fetching playlists");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchGenresSongs = async () => {
//     try {
//       const res = await httpClient.get(`/user/music/get-themes`);
//       if (res.data?.success) {
//         setGenres(res.data.data.getThemes || []);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const fetchSongsPlaylist = async () => {
//     try {
//       const res = await httpClient.get(`/user/music/get-admin-playlist`);
//       if (res.data?.success) {
//         setAdminPlaylist(res.data.data.getPlaylists || []);
//       }
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   useEffect(() => {
//     window.scrollTo(0, 0);
//     fetchGenresSongs();
//     fetchSongsPlaylist();
//   }, []);

//   useEffect(() => {
//     fetchTrendingSongs(currentPage);
//   }, [currentPage]);

//   const handlePageChange = (page) => {
//     setCurrentPage(page);
//     window.scrollTo(0, 0);
//   };

//   const sliderPlaySettings = {
//     dots: false, infinite: true, speed: 500, slidesToShow: 6, slidesToScroll: 3, arrows: false,
//     responsive: [
//       { breakpoint: 1024, settings: { slidesToShow: 4 } },
//       { breakpoint: 768, settings: { slidesToShow: 3 } },
//       { breakpoint: 480, settings: { slidesToShow: 2 } },
//     ],
//   };

//   const sliderSettings = { ...sliderPlaySettings };

//   const CustomNextArrow = (props) => (
//     <div className="swiper-button-next" onClick={props.onClick} style={{ cursor: "pointer" }}>
//       <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
//         <path d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z" fill="currentColor" />
//       </svg>
//     </div>
//   );

//   const CustomPrevArrow = (props) => (
//     <div className="swiper-button-prev" onClick={props.onClick} style={{ cursor: "pointer" }}>
//       <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
//         <path d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z" fill="#4A525F" />
//       </svg>
//     </div>
//   );

//   const renderPagination = () => {
//     if (totalPages <= 1) return null;
//     const pages = [];
//     const maxVisible = 5;
//     let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
//     let end = Math.min(totalPages, start + maxVisible - 1);
//     if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

//     pages.push(
//       <li key="prev" className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
//         <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
//       </li>
//     );

//     for (let i = start; i <= end; i++) {
//       pages.push(
//         <li key={i} className={`page-item ${currentPage === i ? "active" : ""}`}>
//           <button className="page-link" onClick={() => handlePageChange(i)}>{i}</button>
//         </li>
//       );
//     }

//     pages.push(
//       <li key="next" className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
//         <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>Next</button>
//       </li>
//     );

//     return <nav><ul className="pagination justify-content-center">{pages}</ul></nav>;
//   };

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       {/* Breadcrumb */}
//       <div className="row row--grid">
//         <div className="col-12">
//           <ul className="breadcrumb">
//             <li className="breadcrumb__item"><Link to="/">Home</Link></li>
//             <li className="breadcrumb__item breadcrumb__item--active">My Playlist</li>
//           </ul>
//         </div>
//         <div className="col-12">
//           <div className="main__title main__title--page">
//             <h2 className="card-title text-capitalize mt-3">My PlayList</h2>
//           </div>
//         </div>
//       </div>

//       {/* Loading & Error */}
//       {loading && <div className="text-center my-5"><div className="spinner-border text-primary"></div></div>}
//       {error && <div className="alert alert-danger text-center">{error}</div>}

//       {/* My Playlists Grid */}
//       <div className="row row--grid">
//         <div className="col-12">
//           <div className="row row--grid">
//             {playlists.length > 0 ? playlists.map((playlist) => (
//               <div key={playlist._id} className="col-6 col-sm-4 col-lg-3 mb-4">
//                 <div className="live" style={{ cursor: "pointer" }}>
//                   <div className="live__cover" onClick={() => handlePlayAll(playlist._id, "playlist")}>
//                     <img src={playlist.playlistCoverUrl || "img/live/1.jpg"} alt={playlist.name} onError={e => e.target.src = "img/live/1.jpg"} />
//                     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//                       <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
//                     </svg>
//                   </div>
//                   <h5 className="live__title mt-2">
//                     <Link to={`/playlists/${playlist._id}`}>{playlist.name}</Link>
//                   </h5>
//                   {playlist.description && <p className="text-muted small">{playlist.description}</p>}
//                 </div>
//               </div>
//             )) : !loading && <div className="col-12 text-center"><p>No playlists found.</p></div>}
//           </div>
//           {renderPagination()}
//         </div>
//       </div>

//       {/* Wishlist */}
//       <div className="row mt-5">
//         <div className="col-lg-12 mb-5">
//           <div className="card-header mb-3">
//             <div className="header-title">
//               <h4 className="card-title text-capitalize">Wishlist <i className="fa fa-heart text-danger"></i></h4>
//             </div>
//           </div>
//           <div className="row row--grid">
//             <div className="col-12 col-sm-6 col-lg-4 mb-4">
//               <div className="live" onClick={handlelike} style={{ cursor: "pointer" }}>
//                 <div className="live__cover">
//                   <img src={`${process.env.PUBLIC_URL}/img/covers/cover3.jpg`} alt="Wishlist" />
//                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//                     <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
//                   </svg>
//                 </div>
//                 <h3 className="live__title">My Favorite Songs</h3>
//                 <h5 className="live__description text-muted">A collection of my all-time favorite tracks</h5>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Top Song Playlists */}
//       <div className="row">
//         <div className="col-lg-12 mb-5">
//           <div className="card-header mb-3">
//             <div className="header-title">
//               <h4 className="card-title text-capitalize">Top Song Playlists</h4>
//             </div>
//             <div className="common-album position-relative d-lg-block d-none">
//               <CustomPrevArrow onClick={() => sliderPlayRef.current?.slickPrev()} />
//               <CustomNextArrow onClick={() => sliderPlayRef.current?.slickNext()} />
//             </div>
//           </div>
//           <div className="swiper overflow-hidden">
//             <Slider ref={sliderPlayRef} {...sliderPlaySettings}>
//               {adminPlaylist.map((pl) => (
//                 <div key={pl._id} className="swiper-slide mb-3">
//                   <div onClick={() => handlePlayAll(pl._id, "playlist")} style={{ cursor: "pointer" }}>
//                     <img src={pl.coverImageUrl} className="mb-3 img-fluid rounded-3" alt={pl.name} />
//                     <div className="text-capitalize line-count-1 h5 d-block text-white">{pl.name}</div>
//                     <small className="fw-normal text-capitalize text-muted">{pl.description}</small>
//                   </div>
//                 </div>
//               ))}
//             </Slider>
//           </div>
//         </div>
//       </div>

//       {/* Top Genres */}
//       <div className="row">
//         <div className="col-lg-12 mb-5">
//           <div className="card-header mb-3">
//             <div className="header-title">
//               <h4 className="card-title text-capitalize">Top Song Genres</h4>
//             </div>
//             <div className="common-album position-relative d-lg-block d-none">
//               <CustomPrevArrow onClick={() => sliderRef.current?.slickPrev()} />
//               <CustomNextArrow onClick={() => sliderRef.current?.slickNext()} />
//             </div>
//           </div>
//           <div className="swiper overflow-hidden">
//             <Slider ref={sliderRef} {...sliderSettings}>
//             {genres.map((genre) => (
//               <div key={genre._id} className="px-3">
//                 <div className="position-relative d-inline-block w-100">
//                   {/* IMAGE CLICK → playlistId + type: genre */}
//                   <div
// onClick={() => handlePlayAll(genre._id, "genresong")}                    style={{ cursor: "pointer" }}
//                   >
//                     <img
//                       src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
//                       alt={genre.name}
//                       className="img-fluid rounded-3 mb-3 w-100"
//                       style={{
//                         height: "180px",
//                         objectFit: "cover",
//                         transition: "all 0.3s ease"
//                       }}
//                     />

//                     {/* HOVER PLAY BUTTON */}
//                     <div
//                       className="position-absolute top-50 start-50 translate-middle opacity-0"
//                       style={{
//                         transition: "all 0.3s ease",
//                         pointerEvents: "none",
//                         zIndex: 2
//                       }}
//                       onMouseEnter={(e) => {
//                         e.currentTarget.style.opacity = 1;
//                         e.currentTarget.previousElementSibling.style.transform = "scale(1.05)";
//                       }}
//                       onMouseLeave={(e) => {
//                         e.currentTarget.style.opacity = 0;
//                         e.currentTarget.previousElementSibling.style.transform = "scale(1)";
//                       }}
//                     >
//                       <button
//                         className="btn btn-success rounded-circle shadow-lg d-flex align-items-center justify-content-center"
//                         style={{
//                           width: "60px",
//                           height: "60px",
//                           fontSize: "24px",
//                           backgroundColor: "#1DB954",
//                           border: "none"
//                         }}
//                         onClick={(e) => {
//                           e.stopPropagation();
//                           handlePlayAll(genre._id, "genresong")                        }}
//                       >
//                         Play
//                       </button>
//                     </div>

//                     {/* DARK OVERLAY */}
//                     <div
//                       className="position-absolute inset-0 rounded-3 opacity-0"
//                       style={{
//                         background: "rgba(0,0,0,0.5)",
//                         transition: "opacity 0.3s ease"
//                       }}
//                       onMouseEnter={(e) => e.target.style.opacity = 1}
//                       onMouseLeave={(e) => e.target.style.opacity = 0}
//                     ></div>
//                   </div>

//                   {/* TITLE CLICK → NAVIGATE ONLY */}
//                   <Link
//                     to={`/party-music/${genre._id}`}
//                     className="text-decoration-none text-white d-block"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <h6 className="mb-1 text-capitalize">{genre.name}</h6>
//                   </Link>
//                   <small className="text-muted d-block text-capitalize">{genre.description}</small>
//                 </div>
//               </div>
//             ))}
//             </Slider>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Playlist;

import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import httpClient from "../../utils/httpClients";
import { usePlayer } from "../../../PlayerContext";
import Swal from "sweetalert2";

function Playlist() {
  const sliderRef = useRef(null);
  const sliderPlayRef = useRef(null);
  const navigate = useNavigate();

  const [playlists, setPlaylists] = useState([]);
  const [adminPlaylist, setAdminPlaylist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 12;
  const [genres, setGenres] = useState([]);
  const [playlistShareModal, setPlaylistShareModal] = useState({
    open: false,
    song: null,
  });
  const { triggerQueueUpdate, isPlaying, togglePlayPause } = usePlayer();
  const [copiedAlert, setCopiedAlert] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [isMobileView, setIsMobileView] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );
  // === ADD ALL TO QUEUE + NAVIGATE ===
  const playAndNavigate = async (id, type, route) => {
    try {
      const res = await httpClient.post("user/queue/queue-controller", {
        action: "addPlaylistAndPlay",
        playlistId: id,
        type,
      });
      if (res.data?.success) {
        triggerQueueUpdate();
        if (!isPlaying) togglePlayPause();
        navigate(route); // Navigate after queue add
      }
    } catch (err) {
      console.error("Queue failed:", err);
      // Still navigate even if queue fails (optional)
      navigate(route);
    }
  };

  const handleLikeClick = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    const userId = userData?._id;

    if (!userId) {
      alert("Please login to access wishlist");
      navigate("/login");
      return;
    }

    try {
      // Ye backend endpoint hona chahiye jo liked songs add kare queue mein
      const res = await httpClient.post(
        "user/queue/queue-controller",
        {
          action: "addPlaylistAndPlay",
          playlistId: userId,
          type: "like",
        },
        { skipLoader: true, skipErrorToast: true },
      );

      if (res.data?.success) {
        triggerQueueUpdate();
        if (!isPlaying) togglePlayPause();
      }
    } catch (err) {
      console.error("Failed to add liked songs to queue:", err);
    } finally {
      navigate("/like");
    }
  };
  const fetchTrendingSongs = async (page = 1) => {
    try {
      setLoading(true);
      const res = await httpClient.get(
        `user/playlist/get-playlists?page=${page}&limit=${itemsPerPage}`,
      );
      if (res.data?.success) {
        setPlaylists(res.data.data?.playlist || []);
        const totalCount = res.data.data?.totalCount || 0;
        setTotalPages(Math.ceil(totalCount / itemsPerPage));
      }
    } catch (err) {
      setError("Failed to load playlists");
    } finally {
      setLoading(false);
    }
  };

  // Delete Playlist with Confirmation
  const handleDeletePlaylist = async (playlistId, playlistName, e) => {
    e?.stopPropagation();
    e?.preventDefault();

    const result = await Swal.fire({
      title: "Are you sure?",
      text: `Are you sure you want to delete "${playlistName}"?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        await httpClient.delete(`user/playlist/delete-playlist/${playlistId}`);
        // Refresh playlists after deletion
        fetchTrendingSongs(currentPage);
      } catch (err) {
        console.error("Error deleting playlist:", err);
        Swal.fire("Error", "Failed to delete playlist", "error");
      }
    }
  };

  const fetchGenresSongs = async () => {
    try {
      const res = await httpClient.get(`/user/music/get-themes`);
      if (res.data?.success) setGenres(res.data.data.getThemes || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchSongsPlaylist = async () => {
    try {
      const res = await httpClient.get(`/user/music/get-admin-playlist`);
      if (res.data?.success) setAdminPlaylist(res.data.data.getPlaylists || []);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchGenresSongs();
    fetchSongsPlaylist();
    fetchTrendingSongs(currentPage);
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobileView ? 2 : 6,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  const CustomArrow = ({ direction, onClick }) => (
    <div
      className={`swiper-button-${direction}`}
      onClick={onClick}
      style={{ cursor: "pointer" }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
      >
        <path
          d={
            direction === "next"
              ? "M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
              : "M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
          }
          fill={direction === "next" ? "currentColor" : "#4A525F"}
        />
      </svg>
    </div>
  );

  const renderPagination = () => {
    if (totalPages <= 1) return null;
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);

    pages.push(
      <li
        key="prev"
        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
      >
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage - 1)}
        >
          Previous
        </button>
      </li>,
    );
    for (let i = start; i <= end; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>,
      );
    }
    pages.push(
      <li
        key="next"
        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
      >
        <button
          className="page-link"
          onClick={() => handlePageChange(currentPage + 1)}
        >
          Next
        </button>
      </li>,
    );
    return (
      <nav>
        <ul className="pagination justify-content-center mt-4">{pages}</ul>
      </nav>
    );
  };
  // console.log("playlistShare", playlistShareModal.playlist._id);
  const openPlaylistModal = useCallback((playlist, e) => {
    e.preventDefault();
    e.stopPropagation();
    setPlaylistShareModal({ open: true, playlist: playlist });
    // setSelectedPlaylists(null);
    // fetchPlaylists();
    // setOpenDropdown(null);
  }, []);
  const generateShareableUrl = (playlistId) =>
    `${process.env.REACT_APP_FRONTEND_URL || window.location.origin}playlists/${playlistId}`;

  const shareOnSocialMedia = (platform, episode) => {
    const url = generateShareableUrl(episode._id);
    const text = `Check out: ${episode.title}`;
    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`,
      whatsapp: `https://wa.me/?text=${encodeURIComponent(text + " " + url)}`,
      telegram: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`,
    };
    window.open(links[platform], "_blank", "width=600,height=400");
  };
  const copyLink = async () => {
    const text = generateShareableUrl(playlistShareModal.playlist._id);
    try {
      await navigator.clipboard.writeText(text);
      // alert("Copied!");
      setCopiedAlert(true);
    } catch (err) {
      const textarea = document.createElement("textarea");
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand("copy");
      document.body.removeChild(textarea);
      // alert("Copied!");
      setCopiedAlert(true);
    } finally {
      setTimeout(() => {
        setCopiedAlert(false);
      }, 2000);
    }
  };
  const fetchActiveSubscription = async () => {
    try {
      // setLoading(true);
      const res = await httpClient.get("/user/user-subscription/active", {
        skipLoader: true,
        skipToast: true,
      });
      if (res.data && res.data.success) {
        setActiveSubscription(res.data.data.activeSubscriptions[0].features);
      }
    } catch (error) {
      console.error("Error fetching active subscription:", error);
      setActiveSubscription(null);
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveSubscription();
  }, []);
  return (
    <>
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        {/* Breadcrumb */}
        <div className="row row--grid">
          <div className="col-12">
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb__item breadcrumb__item--active">
                My Playlist
              </li>
            </ul>
          </div>
          <div className="col-12">
            <div className="main__title main__title--page">
              <h2 className="card-title text-capitalize mt-3">My PlayList</h2>
            </div>
          </div>
        </div>

        {loading && (
          <div className="text-center my-5">
            <div className="spinner-border text-primary"></div>
          </div>
        )}
        {error && <div className="alert alert-danger text-center">{error}</div>}

        {/* My Playlists */}
        <div className="row row--grid">
          <div className="col-12">
            <div className="row row--grid">
              {playlists.length > 0
                ? playlists.map((pl) => (
                    <div key={pl._id} className="col-6 col-sm-4 col-lg-3 mb-4">
                      <div
                        className="live"
                        style={{ cursor: "pointer", position: "relative" }}
                      >
                        <div
                          className="live__cover"
                          style={{ position: "relative" }}
                          onMouseEnter={(e) => {
                            const buttonContainer =
                              e.currentTarget.querySelector(
                                ".button-container",
                              );
                            if (buttonContainer)
                              buttonContainer.style.opacity = "1";
                          }}
                          onMouseLeave={(e) => {
                            const buttonContainer =
                              e.currentTarget.querySelector(
                                ".button-container",
                              );
                            if (buttonContainer)
                              buttonContainer.style.opacity = "0";
                          }}
                          onClick={() =>
                            playAndNavigate(
                              pl._id,
                              "playlist",
                              `/playlists/${pl._id}`,
                            )
                          }
                        >
                          <img
                            src={
                              pl.playlistCoverUrl || "/img/live/songDefault.png"
                            }
                            alt={pl.name}
                            onError={(e) =>
                              (e.target.src = "/img/live/songDefault.png")
                            }
                          />
                          {/* Play and Trash buttons side by side in the middle */}
                          <div
                            className="button-container"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "12px",
                              opacity: "0",
                              transition: "opacity 0.3s ease",
                              zIndex: 10,
                            }}
                          >
                            {/* Play button */}
                            <div
                              style={{
                                width: "48px",
                                height: "48px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                style={{
                                  fill: "white",
                                  width: "48px",
                                  height: "48px",
                                }}
                              >
                                <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
                              </svg>
                            </div>

                            {/* share button */}
                            {activeSubscription?.includes(
                              "share_playlist_with_friends",
                            ) && (
                              <button
                                className="share-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  openPlaylistModal(pl, e);
                                }}
                                style={{
                                  backgroundColor: "transparent",
                                  color: "white",
                                  border: "none",
                                  width: "48px",
                                  height: "48px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                }}
                                title="Share playlist"
                              >
                                <i
                                  className="fas fa-share"
                                  style={{ fontSize: "24px" }}
                                ></i>
                              </button>
                            )}
                            {/* Trash button */}
                            <button
                              className="trash-btn"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDeletePlaylist(pl._id, pl.name, e);
                              }}
                              style={{
                                backgroundColor: "transparent",
                                color: "#dc3545",
                                border: "none",
                                width: "48px",
                                height: "48px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                              title="Delete playlist"
                            >
                              <i
                                className="fas fa-trash"
                                style={{ fontSize: "24px" }}
                              ></i>
                            </button>
                          </div>
                        </div>
                        <h5 className="live__title mt-2">
                          <Link
                            to={`/playlists/${pl._id}`}
                            onClick={(e) => e.stopPropagation()}
                          >
                            {pl.name}
                          </Link>
                        </h5>
                        {pl.description && (
                          <p className="text-muted small">{pl.description}</p>
                        )}
                      </div>
                    </div>
                  ))
                : !loading && (
                    <div className="col-12 text-center">
                      <p>No playlists found.</p>
                    </div>
                  )}
            </div>
            {renderPagination()}
          </div>
        </div>

        {/* Wishlist */}
        <div className="row mt-5">
          <div className="col-12">
            <h4 className="card-title text-capitalize mb-4">
              Wishlist <i className="fa fa-heart text-danger"></i>
            </h4>
            <div className="row row--grid">
              <div className="col-12 col-sm-6 col-lg-4">
                <div
                  className="live"
                  onClick={handleLikeClick}
                  style={{ cursor: "pointer" }}
                >
                  <div className="live__cover">
                    <img
                      src={`${process.env.PUBLIC_URL}/img/covers/cover3.jpg`}
                      alt="Liked Songs"
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                      <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
                    </svg>
                  </div>
                  <h3 className="live__title text-black mt-2">
                    My Favorite Songs
                  </h3>
                  <p className="text-muted">
                    A collection of my all-time favorite tracks
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Top Song Playlists */}
        <div className="row mt-5">
          <div className="col-12 px-0 px-md-3">
            <div className="card-header mb-3 d-flex justify-content-between align-items-center">
              <h4 className="card-title text-capitalize">Top Song Playlists</h4>
              <div className="common-album position-relative d-lg-block d-none">
                <CustomArrow
                  direction="prev"
                  onClick={() => sliderPlayRef.current?.slickPrev()}
                />
                <CustomArrow
                  direction="next"
                  onClick={() => sliderPlayRef.current?.slickNext()}
                />
              </div>
            </div>
            <Slider ref={sliderPlayRef} {...sliderSettings}>
              {adminPlaylist.map((pl) => (
                <div key={pl._id} className="px-0 px-md-2">
                  <div
                    onClick={() =>
                      playAndNavigate(
                        pl._id,
                        "track",
                        `/admin-playlists/${pl._id}`,
                      )
                    }
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={pl.coverImageUrl}
                      className="img-fluid rounded-3 mb-3 w-100"
                      alt={pl.name}
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                    {/* <h6
                      className="text-black text-capitalize mb-1"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: 1.3,
                        minHeight: "3.9em",
                      }}
                    >
                      {pl.description}
                    </h6> */}
                    <small
                      className="text-muted d-block"
                      style={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        lineHeight: 1.35,
                        minHeight: "2.7em",
                      }}
                    >
                      {pl.description
                        ? pl.description.length > 50
                          ? `${pl.description.slice(0, 50)}...`
                          : pl.description
                        : ""}
                    </small>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>

        {/* Top Genres */}
        <div className="row mt-5">
          <div className="col-12 px-0 px-md-3">
            <div className="card-header mb-3 d-flex justify-content-between align-items-center">
              <h4 className="card-title text-capitalize">Top Song Genres</h4>
              <div className="common-album position-relative d-lg-block d-none">
                <CustomArrow
                  direction="prev"
                  onClick={() => sliderRef.current?.slickPrev()}
                />
                <CustomArrow
                  direction="next"
                  onClick={() => sliderRef.current?.slickNext()}
                />
              </div>
            </div>
            <Slider ref={sliderRef} {...sliderSettings}>
              {genres.map((genre) => (
                <div key={genre._id} className="px-0 px-md-3 mb-3">
                  <div className="position-relative d-inline-block w-100">
                    <div
                      onClick={() =>
                        playAndNavigate(
                          genre._id,
                          "genresong",
                          `/party-music/${genre._id}`,
                        )
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
                        alt={genre.name}
                        className="img-fluid rounded-3 mb-3 w-100"
                        style={{
                          height: "180px",
                          objectFit: "cover",
                          transition: "all 0.3s ease",
                        }}
                      />
                      <div
                        className="position-absolute top-50 start-50 translate-middle opacity-0"
                        style={{
                          transition: "all 0.3s ease",
                          pointerEvents: "none",
                          zIndex: 2,
                        }}
                      >
                        <button
                          className="btn btn-success rounded-circle shadow-lg"
                          style={{
                            width: "60px",
                            height: "60px",
                            backgroundColor: "#1DB954",
                            border: "none",
                          }}
                        >
                          Play
                        </button>
                      </div>
                      <div
                        className="position-absolute inset-0 rounded-3"
                        style={{
                          background: "rgba(0,0,0,0.5)",
                          transition: "opacity 0.3s ease",
                          opacity: 0,
                        }}
                        onMouseEnter={(e) => (e.target.style.opacity = 1)}
                        onMouseLeave={(e) => (e.target.style.opacity = 0)}
                      />
                    </div>
                    <Link
                      to={`/party-music/${genre._id}`}
                      className="text-decoration-none"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <h6 className="mb-1 text-capitalize text-black">
                        {genre.name}
                      </h6>
                    </Link>
                    <small className="text-muted d-block text-capitalize">
                      {genre.description}
                    </small>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
      {/* PLAYLIST MODAL */}

      {/* SHARE MODAL */}
      {playlistShareModal.open && playlistShareModal.playlist && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
          onClick={() => setPlaylistShareModal({ open: false, playlist: null })}
        >
          <div
            className="share-popup"
            style={{
              backgroundColor: "#1a1a1a",
              padding: "25px",
              borderRadius: "12px",
              width: "90%",
              maxWidth: "350px",
              color: "white",
              border: "1px solid #333",
              boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div style={{ textAlign: "center", marginBottom: "25px" }}>
              <h4
                style={{
                  margin: "0 0 10px 0",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#aaa7a7",
                }}
              >
                Share
              </h4>
              <p style={{ margin: 0, color: "#ccc", fontSize: "14px" }}>
                {playlistShareModal.playlist?.title}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "20px",
                marginBottom: "25px",
                flexWrap: "wrap",
              }}
            >
              {["facebook", "twitter", "whatsapp", "telegram"].map((p) => (
                <button
                  key={p}
                  onClick={() =>
                    shareOnSocialMedia(p, playlistShareModal.playlist)
                  }
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "8px",
                    fontSize: "12px",
                    color: "#ccc",
                  }}
                >
                  <div
                    style={{
                      width: "50px",
                      height: "50px",
                      backgroundColor:
                        p === "facebook"
                          ? "#1877f2"
                          : p === "twitter"
                            ? "#000000"
                            : p === "whatsapp"
                              ? "#25d366"
                              : "#0088cc",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className={`fab fa-${
                        p === "twitter"
                          ? "x-twitter"
                          : p === "telegram"
                            ? "telegram-plane"
                            : p
                      }`}
                      style={{ color: "white", fontSize: "20px" }}
                    ></i>
                  </div>
                  {p.charAt(0).toUpperCase() + p.slice(1)}
                </button>
              ))}
            </div>
            <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
              <input
                type="text"
                value={generateShareableUrl(playlistShareModal.playlist._id)}
                readOnly
                style={{
                  flex: 1,
                  padding: "12px 15px",
                  backgroundColor: "#2a2a2a",
                  border: "1px solid #444",
                  borderRadius: "8px",
                  color: "white",
                  fontSize: "14px",
                }}
              />
              <button
                onClick={copyLink}
                style={{
                  padding: "12px 20px",
                  backgroundColor: "#1DB954",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                COPY
              </button>
            </div>
            {copiedAlert && (
              <div style={{ color: "green" }}>
                <p>
                  <i class="fa-solid fa-circle-check"></i> Copied
                </p>
              </div>
            )}
            <button
              onClick={() =>
                setPlaylistShareModal({ open: false, playlist: null })
              }
              style={{
                width: "100%",
                padding: "12px",
                backgroundColor: "transparent",
                color: "#ccc",
                border: "1px solid #444",
                borderRadius: "8px",
                cursor: "pointer",
              }}
            >
              CANCEL
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default Playlist;
